import React, { useState, useEffect} from 'react';
import { useSelector } from "react-redux";
import { useNavigate } from 'react-router-dom';

import { useNotification } from 'config/Notification';

import { fetchCompanySelectedStandards as fetchCompanySelectedStandardsService,fetchMitigationAssessmentReportsquery as fetchAssessmentReportsqueryService} from 'services/modules/cap/standardservice';
 
import '../../styles/cap.css';

import LoadingOverlay from 'components/LoadingOverlay.jsx';

import {
  Box,
  Paper,
  Tab,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TablePagination,
  TableRow,
  Tooltip,
  Tabs,
  tabsClasses
} from '@mui/material';

import WarningIcon from '@mui/icons-material/Warning';

const PendingAssementsPage = () => {

  // State variables
  const [assessmentsList,setAssessmentsList] = useState([]);
  const [loading, setLoading] = useState(true);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [selectedStandards,setSelectedStandards]=useState([])
  const [value, setValue] = useState(0);

  // Redux selectors
  const selectedCompanyContainer = useSelector((state) => state.auth.companyData );
 
  // React router
  const navigate = useNavigate();
  
  // Notification
  const openNotification = useNotification();

  // This method handles to change the pages
  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  // This method handles to change the rows per page based on user selection
  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(+event.target.value);
    setPage(0);
  };

  // Method handles to change the selected standards
  const handleChange = (event, newValue) => {
    setValue((value)=>value=newValue);
    if(newValue===0){
      getPendingAssessments(null);
    }else{
      getPendingAssessments(selectedStandards[newValue-1].id);
    }
  };

  useEffect(()=>{
    if (selectedCompanyContainer?.companyid !== null){
      getCompanySelectedStandards();
      setValue(0);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps 
  },[selectedCompanyContainer]);

  // Method handles to fetch the selected standards of company
  const getCompanySelectedStandards=async ()=>{
    try {
      setSelectedStandards([]);
      let params = {companyid:selectedCompanyContainer.companyid};
      const response = await fetchCompanySelectedStandardsService({  params });
      if(response !== '' && response.data !== undefined){
        setSelectedStandards(response.data);
        getPendingAssessments(null);
      }
    } catch (error) {
      openNotification("Error while fetching standards",'error');
    }
  };

  // Method handles to get the details of pending assessments
  const getPendingAssessments= async(standard) =>{
    setLoading(true);
    setAssessmentsList([]);
    let assessmentsResponse=null;
    let statusArray = ["Submitted","Review Assessment In Progress","Reject Assessment"];
    let params = {company: selectedCompanyContainer.companyid, status: statusArray.join(',')};
    if(standard !== null){
      params.standard=standard;
    }
    assessmentsResponse = await fetchAssessmentReportsqueryService({ params });
    if(assessmentsResponse !== null ){   
      setAssessmentsList(assessmentsResponse);
    }
    setLoading(false);
  };

 
 
  return (
    <div>
      <div className="row py-2">
        <p>
          <img className="px-1 icons-style" src="../assets/icons/003-clipboard.svg" alt="View"   />
          <b className="px-1">Assessments</b>
          <img className="px-1 icons-style" src="../assets/icons/right-layer.svg" alt="View"  />
          Pending
        </p>
      </div>
      <hr/>

      <div>
        {loading && <LoadingOverlay />}

        <div>
          {selectedStandards && selectedStandards.length>0 &&(
            <Box className="cap-tabs-section"
              sx={{
                flexGrow: 1,
                bgcolor: 'background.paper',
              }}
            >
              <Tabs className="cap-tabs"
                value={value}
                onChange={handleChange}
                variant="scrollable"
                scrollButtons
                sx={{
                  [`& .${tabsClasses.scrollButtons}`]: {
                    '&.Mui-disabled': { opacity: 0.3 },
                  },
                }}
              >
                <Tab  key={0} label="All" />
                {selectedStandards.map((tab, index) => (
                  <Tab  key={index+1} label={tab.name} />
                ))}
              </Tabs>
            </Box>
          )}
          {(assessmentsList && assessmentsList.length>0 &&
            <Paper sx={{ width: '100%', overflow: 'hidden' }}>
              <TableContainer sx={{ maxHeight: 440 }}>
                <Table stickyHeader >
                  <TableHead>
                    <TableRow>
                      <TableCell>Assessment id</TableCell>
                      <TableCell>User</TableCell>
                      <TableCell>Standard</TableCell>
                      <TableCell>Assigned date</TableCell>
                      <TableCell>Due date</TableCell>
                      <TableCell>Status</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {(
                      assessmentsList.map((item,index) => (
                        <React.Fragment key={index}>
                          <TableRow>
                            <TableCell className="text-blue text-bold" 
                              onClick={() => navigate('/cap/review-assessment', { state: { assessmentid: item.assessment_id, standard: item.standardname,status:item.status } })}
                            >
                              {item.assessment_id}
                            </TableCell>
                            <TableCell>{item.username}</TableCell>
                            <TableCell>{item.standardname}</TableCell>
                            <TableCell>{new Date(item.created_date).toLocaleDateString()}</TableCell>
                            <TableCell>{new Date(item.due_date).toLocaleDateString()}</TableCell>
                            <TableCell>{item.status}
                              <Tooltip title="Review Assessment" placement="top">
                                <img   src="../assets/icons/right-layer.svg" alt="arrow" className='assessment-status' 
                                  onClick={() => navigate('/cap/review-assessment', { state: { assessmentid: item.assessment_id, standard: item.standardname,status:item.status } })}
                                />
                              </Tooltip>
                            </TableCell>
                          </TableRow>
                        </React.Fragment>
                      )))
                    }
                  </TableBody>
                </Table>
              </TableContainer>
            
              <TablePagination
                rowsPerPageOptions={[10,25,100]}
                component="div"
                count={assessmentsList.length}
                rowsPerPage={rowsPerPage}
                page={page}
                onPageChange={handleChangePage}
                onRowsPerPageChange={handleChangeRowsPerPage}
              />
            </Paper>
          )}
          {assessmentsList && assessmentsList.length === 0 && (
            <Table>
              <TableRow>
                <TableCell colSpan={6}>
                  <WarningIcon color="black" fontSize="small" />
                  No data available
                </TableCell>
              </TableRow>
            </Table>
          )}
        </div>
      </div>
    </div>
  )
}

export default PendingAssementsPage;
